// import * as THREE from "three";
// import { Viewer, ImagePanorama, Infospot } from "panolens";
import { useEffect, useRef, useState } from 'react';
import '../assets/css/location.css';
import locationImg from '../assets/images/TirupatiNamaahMap.jpg';
import distance from '../assets/images/distance.png';
import dahisarIcon from '../assets/images/landmark_icons/dahisar_icon.jpg';
import kashimiraIcon from '../assets/images/landmark_icons/kashimira_icon.jpg';
import wockhardtHospitalIcon from '../assets/images/landmark_icons/wockhardtHospitalIcon.jpg';
import bhayandarStationIcon from '../assets/images/landmark_icons/bhayandarStationIcon.jpg';
import maxusMallIcon from '../assets/images/landmark_icons/maxusMallIcon.jpg';
import dmartIcon from '../assets/images/landmark_icons/dmartIcon.jpg';
import miraRoadStationIcon from '../assets/images/landmark_icons/miraRoadStationIcon.jpg';
import radhaGirdhaiIcon from '../assets/images/landmark_icons/radhaGirdhaiIcon.jpg';
import lrTiwariCollegeIcon from '../assets/images/landmark_icons/lrTiwariCollegeIcon.jpg';
import pleasantParkIcon from '../assets/images/landmark_icons/pleasantParkIcon.jpg';
import silverParkIcon from '../assets/images/landmark_icons/silverParkIcon.jpg';
import gccClubIcon from '../assets/images/landmark_icons/gccClubIcon.jpg';
import beverlyParkicon from '../assets/images/landmark_icons/beverlyParkicon.jpg';
import podarSchoolIcon from '../assets/images/landmark_icons/podarSchoolIcon.jpg';
import chandanShantiIcon from '../assets/images/landmark_icons/chandanShantiIcon.jpg';
import joggersParkIcon from '../assets/images/landmark_icons/joggersParkIcon.jpg';
// import macDIcon from '../assets/images/landmark_icons/macDIcon.jpg';

function LocationSkyCrest8() {
    const [animate, setAnimate] = useState(false);
    const [activePath, setActivePath] = useState(null);
    const containerRef = useRef(null);
    const modalRef = useRef(null);

    useEffect(() => {
        // Hide all paths with stroke #ffff00 initially
        document.querySelectorAll('.animated-path').forEach(path => {
            path.style.strokeDasharray = path.getTotalLength();
            path.style.strokeDashoffset = path.getTotalLength();
            path.style.transition = 'stroke-dashoffset 3s ease-in-out';
        });
    }, []);
    useEffect(() => {
        // Center the view on mobile
        if (window.innerWidth <= 767 && containerRef.current) {
            containerRef.current.scrollLeft = containerRef.current.scrollWidth / 3;
        }
    }, []);
    const handleIconClick = (iconName) => {
        const pathId = `${iconName}_path`;
        const pathElement = document.getElementById(pathId);
        console.log("djhf", pathId, pathElement);
        if (pathElement) {
            // Reset all paths before animating the selected one
            document.querySelectorAll('.animated-path').forEach(path => {
                path.style.strokeDashoffset = path.getTotalLength();
            });

            // Animate the selected path
            // Animate the selected path
            requestAnimationFrame(() => {
                pathElement.style.strokeDashoffset = "0";
            });
            // pathElement.style.strokeDashoffset = '0';
            console.log("sfhdhfs", pathId, pathElement)
            setActivePath(pathId);
        }
    };

    // diatance details
    const [distanceDetails, setDistanceDetails] = useState({});
    const [distanceDetailsModel, setDistanceDetailsModel] = useState(false);

    const handleShowDistance = (details) => {
        setDistanceDetails(details);
        setDistanceDetailsModel(true);
    }

    const checkClickOutside = (e) => {
        if (distanceDetailsModel && modalRef.current && !modalRef.current.contains(e.traget)) {
            setDistanceDetailsModel(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', checkClickOutside);
        return () => document.removeEventListener('mousedown', checkClickOutside);
    }, [distanceDetailsModel])

    return (
        <div className="w-100">
            <div className="location_main_container" ref={containerRef}>
                <img src={locationImg} className="location_image_bg" alt="location_image_bg" />
                {/* <svg
                    className={`location_svg_overlay ${animate ? "animate-path" : ""}`}
                    width="100%"
                    height="100%"
                    viewBox="0 0 1083.7333 609.59998"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(417.29468,210.36641)">
                        <g style={{ fill: "#00ffff", strokeWidth: 0.21956 }} transform="matrix(0.03012645,0,0,0.03012645,120.43779,-51.720731)">
                            <path
                                className="pointer"
                                onClick={() => setAnimate(true)}
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                style={{ fill: "#00ffff", strokeWidth: 0.21956 }}
                            />
                        </g>
                        <path
                            className="animated_path"
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 C 98.63303,-32.879119 90.50408,-66.240385 92.57984,-68.83874 c 2.07575,-2.598355 24.13265,-0.56576 28.0634,0.187454 3.93075,0.753214 6.59763,9.549793 8.62288,12.934316"
                        />
                    </g>
                </svg> */}
                <svg
                    className={`location_svg_overlay ${animate ? "animate-path" : ""}`}
                    width="1083.7333mm"
                    height="609.59998mm"
                    viewBox="0 0 1083.7333 609.59998"
                    id="svg1"
                    xmlSpace="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                >

                    <defs id="defs1" />
                    <g
                        id="layer1"
                        transform="translate(417.29468,210.36641)"
                    >
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-161.76559}
                            y={-109.67713}
                            id="text2"
                        >
                            <tspan
                                id="tspan2"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-161.76559}
                                y={-109.67713}
                            >
                                {"Poddar School"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={61.087597}
                            y={-164.6277}
                            id="text4"
                        >
                            <tspan
                                id="tspan4"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={61.087597}
                                y={-164.6277}
                            >
                                {"KashiMira Shivaji Statue"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={286.53003}
                            y={-110.80865}
                            id="text7"
                        >
                            <tspan
                                id="tspan7"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={286.53003}
                                y={-110.80865}
                            >
                                {"Shri RadhaGirdhai Temple"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-80.006882}
                            y={-19.941803}
                            id="text9"
                        >
                            <tspan
                                id="tspan9"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-80.006882}
                                y={-19.941803}
                            >
                                {"Chandan Shanti"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-79.383949}
                            y={49.779251}
                            id="text10"
                        >
                            <tspan
                                id="tspan10"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-79.383949}
                                y={49.779251}
                            >
                                {"Beverly Park"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={221.81708}
                            y={30.045858}
                            id="text12"
                        >
                            <tspan
                                id="tspan12"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={221.81708}
                                y={30.045858}
                            >
                                {"Wockhardt Hospital"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={362.99643}
                            y={59.26889}
                            id="text14"
                        >
                            <tspan
                                id="tspan14"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={362.99643}
                                y={59.26889}
                            >
                                {"MiraRoad Station"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={495.54712}
                            y={-132.85181}
                            id="text16"
                        >
                            <tspan
                                id="tspan16"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={495.54712}
                                y={-132.85181}
                            >
                                {"Dahisar Station"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={134.27325}
                            y={244.89224}
                            id="text17"
                        >
                            <tspan
                                id="tspan17"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={134.27325}
                                y={244.89224}
                            >
                                {"Maxus Mall"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-33.170643}
                            y={121.95745}
                            id="text18"
                        >
                            <tspan
                                id="tspan18"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-33.170643}
                                y={121.95745}
                            >
                                {"Upcoming Metro St."}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-22.517241}
                            y={90.948341}
                            id="text19"
                        >
                            <tspan
                                id="tspan19"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-22.517241}
                                y={90.948341}
                            >
                                {"Deepak Hospital"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-102.15484}
                            y={265.56726}
                            id="text20"
                        >
                            <tspan
                                id="tspan20"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    textAlign: "center",
                                    textAnchor: "middle",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-102.15484}
                                y={265.56726}
                            >
                                {"Bhayandar "}
                            </tspan>
                            <tspan
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    textAlign: "center",
                                    textAnchor: "middle",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-102.15484}
                                y={283.20615}
                                id="tspan21"
                            >
                                {"East"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-300.49228}
                            y={32.133163}
                            id="text22"
                        >
                            <tspan
                                id="tspan22"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-300.49228}
                                y={32.133163}
                            >
                                {"L.R. Tiwari College"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={285.89105}
                            y={204.00952}
                            id="text23"
                        >
                            <tspan
                                id="tspan23"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={285.89105}
                                y={204.00952}
                            >
                                {"D Mart"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={3.4095554}
                            y={18.296696}
                            id="text24"
                        >
                            <tspan
                                id="tspan24"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={3.4095554}
                                y={18.296696}
                            >
                                {"Mac Donald"}
                            </tspan>
                        </text>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434628"
                            id="Up_Coming_Metro_St._path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 C 98.63303,-32.879119 90.50408,-66.240385 92.57984,-68.83874 c 2.07575,-2.598355 24.13265,-0.56576 28.0634,0.187454 3.93075,0.753214 6.59763,9.549793 8.62288,12.934316"
                            id="Silver_Park_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.32595,81.311814 c 0,0 -2.47008,20.619906 -2.09517,22.119536 0.37491,1.49963 89.37095,3.5331 96.00956,2.43692 3.28213,-0.54195 33.62208,-29.329497 31.49224,-32.242073 -1.32944,-1.818032 -34.02984,-1.412892 -36.1786,-3.561635 -1.09303,-1.093027 5.06127,-29.805153 5.06127,-29.805153"
                            id="Wockhardt_Hospital_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 C 98.63303,-32.879119 85.841628,-90.797788 87.448743,-93.396143 c 1.607116,-2.598355 23.664017,-1.690483 27.782217,-1.780812 4.1182,-0.09033 6.34964,8.872226 8.37489,12.256749"
                            id="Pleasant_Park_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 -1.78246,-9.4429308 -4.710801,-23.5570828 -7.581663,-37.6177888 l -3.452231,-18.965372 c -0.651516,-4.101003 -2.260772,-5.459639 -6.590172,-4.94152 l -134.5432,-0.508669 -37.322305,-17.96136 c -4.314301,-2.191919 -2.335823,-4.157952 0.221124,-5.846884 0,0 20.601225,-14.732421 23.315991,-14.896331 2.183878,-0.13185 7.154795,3.91095 7.154795,3.91095"
                            id="Poddar_School_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 C 98.63303,-32.879119 83.671778,-101.9729 83.953395,-110.13835 c 0.281617,-8.16544 6.444567,-10.3699 14.141614,-15.16572 7.697051,-4.79582 14.211921,-9.02389 17.496391,-11.40529"
                            id="KashiMira_Shivaji_Statue_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="Upcoming_Metro_St."
                            transform="matrix(0.03012645,0,0,0.03012645,99.097576,-2.4503563)"
                            onClick={() => handleIconClick('Up_Coming_Metro_St.')}
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path11"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={128.52164}
                            y={-13.490075}
                            id="text11"
                        >
                            <tspan
                                id="tspan11"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={128.52164}
                                y={-13.490075}
                            >
                                {"Upcoming Metro St."}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={152.59752}
                            y={-96.393959}
                            id="text5"
                        >
                            <tspan
                                id="tspan5"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={152.59752}
                                y={-96.393959}
                            >
                                {"Pleasant Park"}
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-21.306681}
                            y={-55.368656}
                            id="text6"
                        >
                            <tspan
                                id="tspan6"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-21.306681}
                                y={-55.368656}
                            >
                                {"GCC Club"}
                            </tspan>
                        </text>
                        <g
                            style={{
                                fill: "#e3e3e3",
                            }}
                            id="g29"
                            transform="matrix(0.00661458,0,0,0.00661458,346.47003,-9.6019837)"
                        >
                            <path
                                d="M 480,-120 200,-272 v -240 l -160,-88 440,-240 440,240 v 320 h -80 v -276 l -80,44 v 240 z m 0,-332 274,-148 -274,-148 -274,148 z m 0,241 200,-108 V -470 L 480,-360 280,-470 v 151 z m 0,-241 z m 0,90 z m 0,0 z"
                                id="path1-1"
                            />
                        </g>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 0.0204,6.96285 0.54043,7.48291 2.35224,2.35224 144.40881,73.23584 142.27897,70.32326 l 24.89012,-5.13876"
                            id="DMart_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 0.0204,6.96286 0.54043,7.48291 2.13435,2.13435 130.61766,66.35574 152.81103,76.05921 l 2.69992,1.23512 -19.56269,14.87767"
                            id="Maxus_Mall_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 0.0204,6.96287 0.54043,7.48291 0.96218,0.96218 27.45259,14.84432 58.60577,30.05701 L -52.663563,329.05394"
                            id="Bhayandar_Station_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-52.323959}
                            y={338.42743}
                            id="text15"
                        >
                            <tspan
                                id="tspan15"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-52.323959}
                                y={338.42743}
                            >
                                {"Bhayandar Station"}
                            </tspan>
                        </text>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 -0.11391,7.14718 0.54043,7.48291 l 58.12396,30.08018 173.88368,-122.889148"
                            id="Miraroad_Station_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 C 98.63303,-32.879119 83.671778,-101.9729 83.953395,-110.13835 c 0.281617,-8.16544 6.444567,-10.3699 14.141614,-15.16572 7.697051,-4.79582 14.211921,-9.02389 17.496391,-11.40529 0,0 74.50185,1.86657 109.64547,0.25603 35.14362,-1.61054 71.71883,-5.70048 100.99015,-9.51356 29.27132,-3.81308 54.8594,-11.76914 74.64489,-12.44082 19.78549,-0.67168 30.10435,2.82962 42.90302,4.18676 12.79867,1.35714 23.79291,3.10766 33.89427,3.88103 10.10136,0.77337 18.45462,0.87587 26.64969,1.03494 8.19507,0.15907 15.34273,0.90425 22.50993,0 7.1672,-0.90425 12.37795,-3.53358 20.18132,-5.1747 7.80337,-1.64112 17.78406,-5.96759 26.64969,-4.39849 6.04641,1.07013 16.04157,9.05572 16.04157,9.05572 l 17.8527,11.1256 3.10482,1.81114"
                            id="Dahisar_Station_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 -0.11391,7.14718 0.54043,7.48291 l 58.12396,30.08018 234.40002,-165.688143 -9.07169,-5.1532198"
                            id="Joggers_Park_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31013,-30.07845 3.71142,-38.17436 -0.92318,-12.483613 -2.20625,-17.436565 -6.79803,-17.247999 l -146.949761,6.034633"
                            id="Beverly_Park_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -4.6339,-28.784334 -10.95918,-57.410929 -16.705531,-86.02018 13.672861,0.683914 28.820121,2.210345 41.018571,2.051741 8.16961,-0.10622 80.50547,-20.690734 90.9407,-23.380262 10.43523,-2.689527 65.37668,-4.083402 71.1887,-4.14788 0,0 -0.0594,-10.239524 -2.55432,-13.916188 -4.00195,-5.89762 -21.48419,-14.533421 -21.48419,-14.533421"
                            id="Shri_RadhaGirdhai_Temple_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={161.6705}
                            y={-65.199188}
                            id="text8"
                        >
                            <tspan
                                id="tspan8"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={161.6705}
                                y={-65.199188}
                            >
                                {"Silver Park"}
                            </tspan>
                        </text>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31013,-30.07845 3.71142,-38.17436 -0.92318,-12.483613 -2.20485,-17.398616 -6.79803,-17.247999 l -261.11083,8.562184"
                            id="L.R._Tiwari_College_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 -1.78246,-9.4429308 -4.710801,-23.5570828 -7.581663,-37.6177888 L 60.51409,-43.799471 58.262414,-56.960896 45.90061,-55.02471"
                            id="GCC_Club_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="KashiMira_Shivaji_Statue"
                            transform="matrix(0.03012645,0,0,0.03012645,103.76492,-132.17205)"
                            onClick={() => { { handleIconClick('KashiMira_Shivaji_Statue'); handleShowDistance({ name: "KashiMira Shivaji Statue", image: kashimiraIcon, km: "3.5 KM" }); } }}
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path4"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}
                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -4.80578,-26.679757 -9.27852,-49.0434632 -1.78246,-9.4429308 -4.710801,-23.5570828 -7.581663,-37.6177888 l -3.452231,-18.965372 c -0.651516,-4.101003 -2.260772,-5.459639 -6.590172,-4.94152 l -85.71081962,-0.324048 0.8355589,-67.148726"
                            id="KashiMira_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="KashiMira_"
                            onClick={() => handleIconClick('KashiMira')}
                            transform="matrix(0.03012645,0,0,0.03012645,-13.427328,-137.79587)"
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path3"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={-28.967478}
                            y={-169.29166}
                            id="text3"
                        >
                            <tspan
                                id="tspan3"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={-28.967478}
                                y={-169.29166}
                            >
                                {"KashiMira "}
                            </tspan>
                        </text>
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="GCC_Club"
                            transform="matrix(0.03012645,0,0,0.03012645,26.312418,-55.075621)"
                            onClick={() => { handleIconClick('GCC_Club'); handleShowDistance({ name: "GCC Club", image: gccClubIcon, km: "2.8 KM" }); }}
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path6"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <path
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "markers stroke fill",
                            // }}

                            d="m 108.92841,79.387658 c 0,0 4.31012,-30.07845 3.71142,-38.17436 -0.5987,-8.09591 -2.42278,-16.552014 -6.89552,-38.9157205 L 68.181685,3.1735287 63.773097,-23.449983 H 38.900553"
                            id="Chandan_Shanti_path"
                        />
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="Joggers_Park"
                            transform="matrix(0.03012645,0,0,0.03012645,367.96876,9.7988613)"
                            onClick={() => { handleIconClick('Joggers_Park'); handleShowDistance({ name: "Joggers Park", image: joggersParkIcon, km: "2.5 KM" }); }}
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path13"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <text
                            xmlSpace="preserve"
                            style={{
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "bold",
                                fontStretch: "normal",
                                fontSize: "14.1111px",
                                fontFamily: "Calibri",
                                InkscapeFontSpecification: "'Calibri, Bold'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "all-small-caps",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                letterSpacing: 0,
                                opacity: 1,
                                fill: "#f9f9f9",
                                stroke: "none",
                                strokeWidth: 3,
                                strokeLinecap: "square",
                                strokeMiterlimit: 4.2,
                                strokeDasharray: "none",
                                strokeDashoffset: 0.0378709,
                                paintOrder: "markers stroke fill",
                            }}
                            x={346.83029}
                            y={-22.305227}
                            id="text13"
                        >
                            <tspan
                                id="tspan13"
                                style={{
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontSize: "14.1111px",
                                    fontFamily: "Calibri",
                                    InkscapeFontSpecification: "'Calibri, Bold'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "all-small-caps",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 3,
                                    strokeDasharray: "none",
                                }}
                                x={346.83029}
                                y={-22.305227}
                            >
                                {"Joggers Park"}
                            </tspan>
                        </text>
                        <path
                            // style={{
                            //     opacity: 1,
                            //     fill: "none",
                            //     stroke: "#ffff00",
                            //     strokeWidth: 2,
                            //     strokeLinecap: "round",
                            //     strokeLinejoin: "round",
                            //     strokeMiterlimit: 4.2,
                            //     strokeDasharray: "none",
                            //     strokeDashoffset: 0.0378709,
                            //     paintOrder: "stroke fill markers",
                            // }}
                            d="m 108.32595,81.311814 -5.96728,61.307956 c -0.40521,4.16317 -0.11391,7.14718 0.54043,7.48291 l 58.12396,30.08018 173.23292,-122.451527"
                            id="MiraRoad_Station_path"
                            className="animated-path"
                            strokeWidth={2}
                            fill="none"
                        />
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="Upcoming_Metro_Station"
                            transform="matrix(0.03012645,0,0,0.03012645,86.270063,132.44642)"
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path18"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <g
                            style={{
                                fill: "#00ffff",
                                strokeWidth: 0.21956,
                            }}
                            id="Chandan_Shanti"
                            transform="matrix(0.03012645,0,0,0.03012645,15.708426,-9.1391054)"
                            onClick={() => { handleIconClick('Chandan_Shanti'); handleShowDistance({ name: "Chandan Shanti", image: chandanShantiIcon, km: "1.7 KM" }); }}
                        >
                            <path
                                d="m 480,-480 q 33,0 56.5,-23.5 Q 560,-527 560,-560 560,-593 536.5,-616.5 513,-640 480,-640 q -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z m 0,400 Q 319,-217 239.5,-334.5 160,-452 160,-552 q 0,-150 96.5,-239 96.5,-89 223.5,-89 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 641,-217 480,-80 Z"
                                id="path9"
                                style={{
                                    fill: "#00ffff",
                                    stroke: "#000000",
                                    strokeWidth: 132.774,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                            />
                        </g>
                        <g id="Pleasant_Park" onClick={() => { handleIconClick('Pleasant_Park'); handleShowDistance({ name: "Pleasant Park", image: pleasantParkIcon, km: "3.5 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle9"
                                cx={135.11691}
                                cy={-95.301643}
                                r={15.610538}
                            />
                            <g
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 206.286,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="g10"
                                transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                            >
                                <path
                                    d="m 200,-80 v -80 h 240 v -160 h -80 q -83,0 -141.5,-58.5 Q 160,-437 160,-520 q 0,-60 33,-110.5 33,-50.5 89,-73.5 9,-75 65.5,-125.5 Q 404,-880 480,-880 q 76,0 132.5,50.5 56.5,50.5 65.5,125.5 56,23 89,73.5 33,50.5 33,110.5 0,83 -58.5,141.5 Q 683,-320 600,-320 h -80 v 160 h 240 v 80 z m 160,-320 h 240 q 50,0 85,-35 35,-35 35,-85 0,-36 -20.5,-66 -20.5,-30 -53.5,-44 l -42,-18 -6,-46 q -6,-45 -39.5,-75.5 Q 525,-800 480,-800 q -45,0 -78.5,30.5 Q 368,-739 362,-694 l -6,46 -42,18 q -33,14 -53.5,44 -20.5,30 -20.5,66 0,50 35,85 35,35 85,35 z m 120,-200 z"
                                    id="path10"
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="g11" transform="translate(0,2.1364485)" onClick={() => { handleIconClick('Shri_RadhaGirdhai_Temple'); handleShowDistance({ name: "Shri RadhaGirdhai Temple", image: radhaGirdhaiIcon, km: "4.1 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle10"
                                cx={268.05826}
                                cy={-117.20675}
                                r={15.610538}
                            />
                            <path
                                id="Shri_RadhaGirdhai_Temple"
                                style={{
                                    opacity: 1,
                                    fill: "#ffffff",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "butt",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                d="m 268.05813,-115.41451 c -1.07184,0 -1.93466,0.85898 -1.93466,1.92605 v 4.81526 h 3.86958 v -4.81526 c 0,-1.06707 -0.8631,-1.92605 -1.93492,-1.92605 z m -7.85192,8.18511 v -0.37224 h 7.85205 7.85206 v 0.37224 0.37224 h -7.85206 -7.85205 z m 0,-5.95589 v -4.83916 h 1.12172 1.12172 v 4.83916 4.83916 h -1.12172 -1.12172 z m 13.46066,0 v -4.83916 h 1.12172 1.12173 v 4.83916 4.83916 h -1.12173 -1.12172 z m -14.87495,-6.67738 -0.54872,-1.11673 9.81506,-0.023 9.81506,0.023 -0.54871,1.11673 -0.54872,1.09373 h -8.71763 -8.71763 z m 1.09101,-2.59385 -0.23757,-0.74448 8.4129,-0.0349 8.41291,0.0349 -0.23757,0.74448 -0.23757,0.70964 h -7.93777 -7.93776 z m 1.4489,-1.54208 6.78714,-3.55773 6.66573,3.55754 -6.72644,0.0185 -6.72643,-0.0182 z"
                            />
                        </g>
                        <g id="g13" onClick={() => { handleIconClick('Poddar_School'); handleShowDistance({ name: "Poddar School", image: podarSchoolIcon, km: "3.8 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle11"
                                cx={-47.087872}
                                cy={-113.1578}
                                r={15.610538}
                            />
                            <g
                                style={{
                                    fill: "#ffffff",
                                    stroke: "none",
                                    strokeWidth: 239.485,
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="Poddar_School"
                                transform="matrix(0.02556281,0,0,0.02455472,-59.358022,-101.37153)"
                            >
                                <path
                                    d="M 480,-120 200,-272 v -240 l -160,-88 440,-240 440,240 v 320 h -80 v -276 l -80,44 v 240 z m 0,-332 274,-148 -274,-148 -274,148 z m 0,241 200,-108 V -470 L 480,-360 280,-470 v 151 z m 0,-241 z m 0,90 z m 0,0 z"
                                    id="path34"
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 239.485,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="L.R._Tiwari_College" transform="translate(-124.38074,143.01267)" onClick={() => { handleIconClick('L.R._Tiwari_College'); handleShowDistance({ name: "L.R. Tiwari College", image: lrTiwariCollegeIcon, km: "3.0 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle13"
                                cx={-47.087872}
                                cy={-113.1578}
                                r={15.610538}
                            />
                            <g
                                style={{
                                    fill: "#ffffff",
                                    stroke: "none",
                                    strokeWidth: 239.485,
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="g14"
                                transform="matrix(0.02556281,0,0,0.02455472,-59.358022,-101.37153)"
                            >
                                <path
                                    d="M 480,-120 200,-272 v -240 l -160,-88 440,-240 440,240 v 320 h -80 v -276 l -80,44 v 240 z m 0,-332 274,-148 -274,-148 -274,148 z m 0,241 200,-108 V -470 L 480,-360 280,-470 v 151 z m 0,-241 z m 0,90 z m 0,0 z"
                                    id="path14"
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 239.485,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="Silver_Park" transform="translate(8.0570517,33.235338)" onClick={() => { handleIconClick('Silver_Park'); handleShowDistance({ name: "Silver Park", image: silverParkIcon, km: "3.0 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle16"
                                cx={135.11691}
                                cy={-95.301643}
                                r={15.610538}
                            />
                            <g
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 206.286,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="g17"
                                transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                            >
                                <path
                                    d="m 200,-80 v -80 h 240 v -160 h -80 q -83,0 -141.5,-58.5 Q 160,-437 160,-520 q 0,-60 33,-110.5 33,-50.5 89,-73.5 9,-75 65.5,-125.5 Q 404,-880 480,-880 q 76,0 132.5,50.5 56.5,50.5 65.5,125.5 56,23 89,73.5 33,50.5 33,110.5 0,83 -58.5,141.5 Q 683,-320 600,-320 h -80 v 160 h 240 v 80 z m 160,-320 h 240 q 50,0 85,-35 35,-35 35,-85 0,-36 -20.5,-66 -20.5,-30 -53.5,-44 l -42,-18 -6,-46 q -6,-45 -39.5,-75.5 Q 525,-800 480,-800 q -45,0 -78.5,30.5 Q 368,-739 362,-694 l -6,46 -42,18 q -33,14 -53.5,44 -20.5,30 -20.5,66 0,50 35,85 35,35 85,35 z m 120,-200 z"
                                    id="path16"
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="Beverly_Park" transform="translate(-174.23375,118.84152)" onClick={() => { handleIconClick('Beverly_Park'); handleShowDistance({ name: "Beverly Park", image: beverlyParkicon, km: "1.8 KM" }); }}>
                            <circle
                                style={{
                                    opacity: 0.5,
                                    fill: "#000000",
                                    stroke: "none",
                                    strokeWidth: 4.99999,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 4.2,
                                    strokeDasharray: "none",
                                    strokeDashoffset: 0.0378709,
                                    paintOrder: "stroke fill markers",
                                }}
                                id="circle18"
                                cx={135.11691}
                                cy={-95.301643}
                                r={15.610538}
                            />
                            <g
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 206.286,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="g19"
                                transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                            >
                                <path
                                    d="m 200,-80 v -80 h 240 v -160 h -80 q -83,0 -141.5,-58.5 Q 160,-437 160,-520 q 0,-60 33,-110.5 33,-50.5 89,-73.5 9,-75 65.5,-125.5 Q 404,-880 480,-880 q 76,0 132.5,50.5 56.5,50.5 65.5,125.5 56,23 89,73.5 33,50.5 33,110.5 0,83 -58.5,141.5 Q 683,-320 600,-320 h -80 v 160 h 240 v 80 z m 160,-320 h 240 q 50,0 85,-35 35,-35 35,-85 0,-36 -20.5,-66 -20.5,-30 -53.5,-44 l -42,-18 -6,-46 q -6,-45 -39.5,-75.5 Q 525,-800 480,-800 q -45,0 -78.5,30.5 Q 368,-739 362,-694 l -6,46 -42,18 q -33,14 -53.5,44 -20.5,30 -20.5,66 0,50 35,85 35,35 85,35 z m 120,-200 z"
                                    id="path19"
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="g23" onClick={() => { handleIconClick('Wockhardt_Hospital'); handleShowDistance({ name: "Wockhardt Hospital", image: wockhardtHospitalIcon, km: "1.0 KM" }); }}>
                            <g id="g22" transform="translate(69.24619,121.65571)">
                                <circle
                                    style={{
                                        opacity: 0.5,
                                        fill: "#000000",
                                        stroke: "none",
                                        strokeWidth: 4.99999,
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 4.2,
                                        strokeDasharray: "none",
                                        strokeDashoffset: 0.0378709,
                                        paintOrder: "stroke fill markers",
                                    }}
                                    id="circle20"
                                    cx={135.11691}
                                    cy={-95.301643}
                                    r={15.610538}
                                />
                                <g
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g21"
                                    transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                />
                            </g>
                            <g
                                style={{
                                    fill: "#ffffff",
                                    stroke: "none",
                                    strokeWidth: 172.412,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="Wockhardt_Hospital"
                                transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                            >
                                <path
                                    d="M 420,-280 H 540 V -420 H 680 V -540 H 540 V -680 H 420 v 140 H 280 v 120 h 140 z m -220,160 q -33,0 -56.5,-23.5 Q 120,-167 120,-200 v -560 q 0,-33 23.5,-56.5 Q 167,-840 200,-840 h 560 q 33,0 56.5,23.5 23.5,23.5 23.5,56.5 v 560 q 0,33 -23.5,56.5 Q 793,-120 760,-120 Z m 0,-80 H 760 V -760 H 200 Z m 0,-560 v 560 z"
                                    id="path48"
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 172.412,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="g27" transform="translate(-113.30229,59.420757)">
                            <g id="g25" transform="translate(69.24619,121.65571)">
                                <circle
                                    style={{
                                        opacity: 0.5,
                                        fill: "#000000",
                                        stroke: "none",
                                        strokeWidth: 4.99999,
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 4.2,
                                        strokeDasharray: "none",
                                        strokeDashoffset: 0.0378709,
                                        paintOrder: "stroke fill markers",
                                    }}
                                    id="circle23"
                                    cx={135.11691}
                                    cy={-95.301643}
                                    r={15.610538}
                                />
                                <g
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g24"
                                    transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                />
                            </g>
                            <g
                                style={{
                                    fill: "#ffffff",
                                    stroke: "none",
                                    strokeWidth: 172.412,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="g26"
                                transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                            >
                                <path
                                    d="M 420,-280 H 540 V -420 H 680 V -540 H 540 V -680 H 420 v 140 H 280 v 120 h 140 z m -220,160 q -33,0 -56.5,-23.5 Q 120,-167 120,-200 v -560 q 0,-33 23.5,-56.5 Q 167,-840 200,-840 h 560 q 33,0 56.5,23.5 23.5,23.5 23.5,56.5 v 560 q 0,33 -23.5,56.5 Q 793,-120 760,-120 Z m 0,-80 H 760 V -760 H 200 Z m 0,-560 v 560 z"
                                    id="path25"
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 172.412,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                        <g id="MiraRoad_Station1" transform="translate(19.940186,-38.099998)" onClick={() => { handleIconClick('MiraRoad_Station'); handleShowDistance({ name: "MiraRoad Station", image: miraRoadStationIcon, km: "2.1 KM" }); }}>
                            <g id="g32" transform="translate(122.48971,66.229903)">
                                <g id="g30" transform="translate(69.24619,121.65571)">
                                    <circle
                                        style={{
                                            opacity: 0.5,
                                            fill: "#000000",
                                            stroke: "none",
                                            strokeWidth: 4.99999,
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: 4.2,
                                            strokeDasharray: "none",
                                            strokeDashoffset: 0.0378709,
                                            paintOrder: "stroke fill markers",
                                        }}
                                        id="circle27"
                                        cx={135.11691}
                                        cy={-95.301643}
                                        r={15.610538}
                                    />
                                    <g
                                        style={{
                                            fill: "#f9f9f9",
                                            stroke: "none",
                                            strokeWidth: 206.286,
                                            strokeDasharray: "none",
                                            paintOrder: "stroke markers fill",
                                        }}
                                        id="g28"
                                        transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                    />
                                </g>
                                <g
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 172.412,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g31"
                                    transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                                />
                            </g>
                            <path
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                d="m 318.22332,103.22604 c -0.16967,-0.085 -0.29527,-0.3009 -0.2572,-0.44225 0.0139,-0.0537 0.60888,-0.90155 1.32096,-1.88416 1.08465,-1.496698 1.27968,-1.796103 1.20191,-1.845189 -0.52176,-0.329276 -0.66486,-0.448752 -0.82952,-0.692527 -0.10493,-0.155398 -0.21797,-0.379427 -0.25128,-0.497897 -0.0395,-0.14043 -0.0606,-2.400463 -0.0608,-6.491016 -4.6e-4,-7.123749 -0.0331,-6.637739 0.48365,-7.197074 0.42855,-0.463933 0.72138,-0.56673 1.73621,-0.609431 l 0.82885,-0.03501 0.0462,-0.372218 c 0.0793,-0.636229 0.41162,-1.077917 0.92594,-1.230367 0.15766,-0.04665 1.2228,-0.06653 3.53415,-0.06563 3.20228,5.6e-4 3.31716,0.0045 3.57503,0.120858 0.51246,0.229763 0.75216,0.58256 0.80962,1.191191 l 0.0352,0.371177 0.83579,0.02601 c 0.67788,0.02075 0.88746,0.04883 1.10944,0.147114 0.3717,0.16437 0.73921,0.505415 0.92984,0.862753 l 0.15811,0.296589 0.0161,6.351693 c 0.0185,7.022312 0.0332,6.709156 -0.3592,7.219566 -0.1068,0.139048 -0.33455,0.336133 -0.50593,0.437918 -0.17128,0.101756 -0.30998,0.207197 -0.30797,0.234291 0.003,0.02719 0.57627,0.843026 1.27611,1.813179 1.35135,1.87327 1.41108,1.98907 1.14793,2.22486 -0.11603,0.10382 -0.24985,0.11258 -1.93895,0.12661 -1.38732,0.0116 -1.84927,-0.003 -1.96244,-0.0602 -0.10585,-0.054 -0.19717,-0.20421 -0.32064,-0.52764 l -0.1729,-0.45228 h -4.36356 -4.36365 l -0.17243,0.45314 c -0.12298,0.32352 -0.21429,0.47411 -0.31855,0.52631 -0.20873,0.10453 -3.57721,0.1043 -3.78608,-2e-4 z m 3.87463,-2.29713 c 0.30153,-0.83765 0.56705,-1.582297 0.59002,-1.654788 0.0413,-0.130538 0.0363,-0.131687 -0.54423,-0.131687 h -0.58598 l -1.14976,1.590685 c -0.63237,0.87488 -1.17138,1.62668 -1.19779,1.67065 -0.0401,0.0667 0.14979,0.0773 1.14568,0.0642 l 1.19373,-0.016 z m 12.3838,1.4636 c -0.0185,-0.0489 -0.54764,-0.80002 -1.17494,-1.66943 l -1.14057,-1.580759 h -0.57794 c -0.31783,0 -0.57789,0.01605 -0.57789,0.03614 0,0.02833 0.89652,2.539539 1.13199,3.170959 0.0488,0.13052 0.06,0.13168 1.21147,0.13168 1.01358,0 1.15789,-0.0116 1.12788,-0.0886 z m -3.69859,-1.40473 -0.15765,-0.43904 -3.75981,-2.3e-4 -3.75985,-2.4e-4 -0.15974,0.43933 -0.15973,0.43932 h 4.07715 4.07711 z m -0.4832,-1.30167 c 0,-0.02307 -0.0435,-0.15493 -0.0969,-0.29287 l -0.0969,-0.250919 h -3.2418 -3.24179 l -0.0952,0.235491 c -0.0523,0.129608 -0.0952,0.26132 -0.0952,0.292896 0,0.03684 1.23137,0.05736 3.43386,0.05736 1.88864,0 3.43388,-0.01833 3.43388,-0.04184 z m -6.36889,-1.700676 c 0.0929,-0.92809 0.26117,-1.319252 0.64448,-1.499194 0.18006,-0.08453 0.47277,-0.09714 2.28081,-0.09714 1.22525,0 2.13725,0.0236 2.2283,0.05808 0.34258,0.128924 0.595,0.54317 0.65381,1.073017 0.0185,0.167362 0.0476,0.416159 0.0643,0.553077 l 0.0308,0.248954 h 1.52696 c 1.48603,0 1.53219,-0.0045 1.72266,-0.131917 0.10771,-0.07246 0.25147,-0.206276 0.31959,-0.297164 0.12366,-0.165069 0.12389,-0.17681 0.13939,-6.463379 l 0.0161,-6.298002 -0.13176,-0.231923 c -0.0726,-0.127547 -0.22606,-0.289908 -0.34122,-0.360817 l -0.20944,-0.128919 h -6.0136 -6.01361 l -0.23806,0.155857 c -0.46566,0.3049 -0.43415,-0.190854 -0.43415,6.829622 v 6.264811 l 0.13453,0.197522 c 0.074,0.108659 0.22444,0.257585 0.33438,0.330848 0.19486,0.130071 0.23654,0.133287 1.72608,0.133287 h 1.5263 z m -1.98082,-1.214039 c -0.14746,-0.04699 -0.38172,-0.181413 -0.52041,-0.298892 -0.75939,-0.643142 -0.76544,-1.802808 -0.0138,-2.440251 0.25593,-0.216635 0.72429,-0.396129 1.03425,-0.396129 0.56541,0 1.1949,0.386833 1.47324,0.905302 0.18099,0.336918 0.18076,1.074394 -2.4e-4,1.411568 -0.16134,0.300391 -0.45474,0.58813 -0.75683,0.742057 -0.3012,0.153323 -0.86399,0.188779 -1.21726,0.07618 z m 0.86089,-0.817983 c 0.25774,-0.106595 0.44299,-0.401963 0.44299,-0.706443 0,-0.619393 -0.67877,-0.994927 -1.1897,-0.658212 -0.42647,0.281022 -0.50839,0.784232 -0.18885,1.159923 0.251,0.295139 0.55562,0.361808 0.93556,0.204654 z m 7.98366,0.840519 c -0.63982,-0.183483 -1.14661,-0.863592 -1.14553,-1.537437 5.6e-4,-0.629818 0.36847,-1.198462 0.94669,-1.465102 0.4017,-0.185318 1.00165,-0.170589 1.39842,0.03407 1.01958,0.525926 1.17766,1.910465 0.30272,2.651437 -0.38809,0.328644 -1.00657,0.459174 -1.5023,0.317038 z m 1.02242,-1.0075 c 0.36134,-0.390094 0.29726,-0.90325 -0.14956,-1.197674 -0.66623,-0.439064 -1.47292,0.327962 -1.09843,1.044463 0.23973,0.458669 0.89097,0.538622 1.24797,0.153093 z m -6.80692,-0.265824 c -0.13015,-0.142281 -0.12459,-0.436632 0.009,-0.557457 0.0957,-0.08567 0.31277,-0.09691 1.85577,-0.09691 1.61777,0 1.75477,0.0074 1.84549,0.107048 0.13014,0.142275 0.12458,0.436648 -0.009,0.557445 -0.0957,0.08567 -0.3128,0.09692 -1.85577,0.09692 -1.61778,0 -1.7548,-0.0074 -1.84549,-0.107046 z m -3.42351,-2.881878 c -0.11951,-0.06238 -0.27935,-0.199602 -0.35524,-0.304922 l -0.138,-0.191313 -0.0161,-2.727352 -0.0161,-2.727351 0.13637,-0.200056 c 0.19371,-0.284316 0.47612,-0.452875 0.83211,-0.496577 0.16944,-0.02075 1.02718,-0.02903 1.90638,-0.0184 1.71899,0.02075 1.78821,0.03244 2.07957,0.350549 0.29068,0.317384 0.28753,0.288186 0.30701,2.852572 0.0115,1.575808 -0.004,2.524897 -0.0451,2.715935 -0.0805,0.371541 -0.24648,0.602775 -0.53823,0.75004 -0.21452,0.1082 -0.35046,0.115801 -2.08198,0.113267 -1.7158,-0.0028 -1.86856,-0.01158 -2.06978,-0.11603 z m 3.85627,-0.814637 c 0.0393,-0.07275 0.0612,-0.957573 0.0612,-2.470271 0,-2.110952 -0.009,-2.368122 -0.098,-2.464061 -0.0904,-0.09876 -0.22398,-0.107049 -1.72708,-0.107049 -1.43281,0 -1.64214,0.01146 -1.73736,0.09693 -0.10147,0.09093 -0.10841,0.245217 -0.10841,2.464045 0,1.519728 0.0208,2.407696 0.0612,2.480451 0.0584,0.10797 0.14123,0.113261 1.77406,0.113261 1.63277,0 1.71565,-0.0045 1.77406,-0.113261 z m 2.57762,0.84109 c -0.23901,-0.123392 -0.37788,-0.253614 -0.49462,-0.464046 -0.0852,-0.154011 -0.0999,-0.486173 -0.11535,-2.677649 -0.0115,-1.74742 0.003,-2.576903 0.0501,-2.750966 0.089,-0.326709 0.42817,-0.661148 0.7605,-0.749687 0.17498,-0.04654 0.7997,-0.06237 1.98119,-0.0495 1.47067,0.01605 1.75174,0.03289 1.90312,0.115571 0.23023,0.125691 0.4201,0.329742 0.49928,0.536565 0.0413,0.107971 0.063,1.068207 0.0622,2.782398 -5.6e-4,2.606952 -5.6e-4,2.618441 -0.1343,2.850614 -0.0749,0.130759 -0.23696,0.291107 -0.36908,0.365141 -0.23068,0.129154 -0.27529,0.131917 -2.10055,0.132605 -1.57687,4.36e-4 -1.89238,-0.01387 -2.04245,-0.09093 z m 3.81651,-0.84109 c 0.0393,-0.07275 0.0612,-0.950414 0.0612,-2.447209 0,-2.017546 -0.0115,-2.351521 -0.0922,-2.46405 -0.0915,-0.129159 -0.10425,-0.130077 -1.74231,-0.130077 -1.42118,0 -1.66307,0.01376 -1.74318,0.0921 -0.0817,0.08057 -0.0929,0.389686 -0.0929,2.507064 0,1.800263 0.0184,2.432934 0.071,2.485334 0.0519,0.05157 0.52843,0.07045 1.77405,0.07045 1.62314,0 1.70589,-0.0045 1.7643,-0.113268 z m -2.87752,6.073469 c -0.0208,-0.233572 -0.0608,-0.483986 -0.0878,-0.556482 l -0.0492,-0.131906 h -1.95667 -1.95671 l -0.0494,0.131906 c -0.0273,0.07246 -0.0682,0.32291 -0.0908,0.556482 l -0.0413,0.424684 h 2.13536 2.13537 z m 1.50341,-14.640735 c -0.0231,-0.236011 -0.0652,-0.334361 -0.18839,-0.439317 l -0.15904,-0.135138 h -3.24965 -3.24968 l -0.16065,0.136749 c -0.12088,0.102674 -0.17036,0.211803 -0.19994,0.439333 l -0.0393,0.302596 h 3.63801 3.63802 z"
                                id="MiraRoad_Station"
                            />
                        </g>
                        <g id="Bhayandar_Station" transform="translate(-395.76942,241.89303)" onClick={() => { handleIconClick('Bhayandar_Station'); handleShowDistance({ name: "Bhayandar Station", image: bhayandarStationIcon, km: "2.8 KM" }); }}>
                            <g id="g37" transform="translate(122.48971,66.229903)">
                                <g id="g35" transform="translate(69.24619,121.65571)">
                                    <circle
                                        style={{
                                            opacity: 0.5,
                                            fill: "#000000",
                                            stroke: "none",
                                            strokeWidth: 4.99999,
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: 4.2,
                                            strokeDasharray: "none",
                                            strokeDashoffset: 0.0378709,
                                            paintOrder: "stroke fill markers",
                                        }}
                                        id="circle33"
                                        cx={135.11691}
                                        cy={-95.301643}
                                        r={15.610538}
                                    />
                                    <g
                                        style={{
                                            fill: "#f9f9f9",
                                            stroke: "none",
                                            strokeWidth: 206.286,
                                            strokeDasharray: "none",
                                            paintOrder: "stroke markers fill",
                                        }}
                                        id="g34"
                                        transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                    />
                                </g>
                                <g
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 172.412,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g36"
                                    transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                                />
                            </g>
                            <path
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                d="m 318.22332,103.22604 c -0.16967,-0.085 -0.29527,-0.3009 -0.2572,-0.44225 0.0139,-0.0537 0.60888,-0.90155 1.32096,-1.88416 1.08465,-1.496698 1.27968,-1.796103 1.20191,-1.845189 -0.52176,-0.329276 -0.66486,-0.448752 -0.82952,-0.692527 -0.10493,-0.155398 -0.21797,-0.379427 -0.25128,-0.497897 -0.0395,-0.14043 -0.0606,-2.400463 -0.0608,-6.491016 -4.6e-4,-7.123749 -0.0331,-6.637739 0.48365,-7.197074 0.42855,-0.463933 0.72138,-0.56673 1.73621,-0.609431 l 0.82885,-0.03501 0.0462,-0.372218 c 0.0793,-0.636229 0.41162,-1.077917 0.92594,-1.230367 0.15766,-0.04665 1.2228,-0.06653 3.53415,-0.06563 3.20228,5.6e-4 3.31716,0.0045 3.57503,0.120858 0.51246,0.229763 0.75216,0.58256 0.80962,1.191191 l 0.0352,0.371177 0.83579,0.02601 c 0.67788,0.02075 0.88746,0.04883 1.10944,0.147114 0.3717,0.16437 0.73921,0.505415 0.92984,0.862753 l 0.15811,0.296589 0.0161,6.351693 c 0.0185,7.022312 0.0332,6.709156 -0.3592,7.219566 -0.1068,0.139048 -0.33455,0.336133 -0.50593,0.437918 -0.17128,0.101756 -0.30998,0.207197 -0.30797,0.234291 0.003,0.02719 0.57627,0.843026 1.27611,1.813179 1.35135,1.87327 1.41108,1.98907 1.14793,2.22486 -0.11603,0.10382 -0.24985,0.11258 -1.93895,0.12661 -1.38732,0.0116 -1.84927,-0.003 -1.96244,-0.0602 -0.10585,-0.054 -0.19717,-0.20421 -0.32064,-0.52764 l -0.1729,-0.45228 h -4.36356 -4.36365 l -0.17243,0.45314 c -0.12298,0.32352 -0.21429,0.47411 -0.31855,0.52631 -0.20873,0.10453 -3.57721,0.1043 -3.78608,-2e-4 z m 3.87463,-2.29713 c 0.30153,-0.83765 0.56705,-1.582297 0.59002,-1.654788 0.0413,-0.130538 0.0363,-0.131687 -0.54423,-0.131687 h -0.58598 l -1.14976,1.590685 c -0.63237,0.87488 -1.17138,1.62668 -1.19779,1.67065 -0.0401,0.0667 0.14979,0.0773 1.14568,0.0642 l 1.19373,-0.016 z m 12.3838,1.4636 c -0.0185,-0.0489 -0.54764,-0.80002 -1.17494,-1.66943 l -1.14057,-1.580759 h -0.57794 c -0.31783,0 -0.57789,0.01605 -0.57789,0.03614 0,0.02833 0.89652,2.539539 1.13199,3.170959 0.0488,0.13052 0.06,0.13168 1.21147,0.13168 1.01358,0 1.15789,-0.0116 1.12788,-0.0886 z m -3.69859,-1.40473 -0.15765,-0.43904 -3.75981,-2.3e-4 -3.75985,-2.4e-4 -0.15974,0.43933 -0.15973,0.43932 h 4.07715 4.07711 z m -0.4832,-1.30167 c 0,-0.02307 -0.0435,-0.15493 -0.0969,-0.29287 l -0.0969,-0.250919 h -3.2418 -3.24179 l -0.0952,0.235491 c -0.0523,0.129608 -0.0952,0.26132 -0.0952,0.292896 0,0.03684 1.23137,0.05736 3.43386,0.05736 1.88864,0 3.43388,-0.01833 3.43388,-0.04184 z m -6.36889,-1.700676 c 0.0929,-0.92809 0.26117,-1.319252 0.64448,-1.499194 0.18006,-0.08453 0.47277,-0.09714 2.28081,-0.09714 1.22525,0 2.13725,0.0236 2.2283,0.05808 0.34258,0.128924 0.595,0.54317 0.65381,1.073017 0.0185,0.167362 0.0476,0.416159 0.0643,0.553077 l 0.0308,0.248954 h 1.52696 c 1.48603,0 1.53219,-0.0045 1.72266,-0.131917 0.10771,-0.07246 0.25147,-0.206276 0.31959,-0.297164 0.12366,-0.165069 0.12389,-0.17681 0.13939,-6.463379 l 0.0161,-6.298002 -0.13176,-0.231923 c -0.0726,-0.127547 -0.22606,-0.289908 -0.34122,-0.360817 l -0.20944,-0.128919 h -6.0136 -6.01361 l -0.23806,0.155857 c -0.46566,0.3049 -0.43415,-0.190854 -0.43415,6.829622 v 6.264811 l 0.13453,0.197522 c 0.074,0.108659 0.22444,0.257585 0.33438,0.330848 0.19486,0.130071 0.23654,0.133287 1.72608,0.133287 h 1.5263 z m -1.98082,-1.214039 c -0.14746,-0.04699 -0.38172,-0.181413 -0.52041,-0.298892 -0.75939,-0.643142 -0.76544,-1.802808 -0.0138,-2.440251 0.25593,-0.216635 0.72429,-0.396129 1.03425,-0.396129 0.56541,0 1.1949,0.386833 1.47324,0.905302 0.18099,0.336918 0.18076,1.074394 -2.4e-4,1.411568 -0.16134,0.300391 -0.45474,0.58813 -0.75683,0.742057 -0.3012,0.153323 -0.86399,0.188779 -1.21726,0.07618 z m 0.86089,-0.817983 c 0.25774,-0.106595 0.44299,-0.401963 0.44299,-0.706443 0,-0.619393 -0.67877,-0.994927 -1.1897,-0.658212 -0.42647,0.281022 -0.50839,0.784232 -0.18885,1.159923 0.251,0.295139 0.55562,0.361808 0.93556,0.204654 z m 7.98366,0.840519 c -0.63982,-0.183483 -1.14661,-0.863592 -1.14553,-1.537437 5.6e-4,-0.629818 0.36847,-1.198462 0.94669,-1.465102 0.4017,-0.185318 1.00165,-0.170589 1.39842,0.03407 1.01958,0.525926 1.17766,1.910465 0.30272,2.651437 -0.38809,0.328644 -1.00657,0.459174 -1.5023,0.317038 z m 1.02242,-1.0075 c 0.36134,-0.390094 0.29726,-0.90325 -0.14956,-1.197674 -0.66623,-0.439064 -1.47292,0.327962 -1.09843,1.044463 0.23973,0.458669 0.89097,0.538622 1.24797,0.153093 z m -6.80692,-0.265824 c -0.13015,-0.142281 -0.12459,-0.436632 0.009,-0.557457 0.0957,-0.08567 0.31277,-0.09691 1.85577,-0.09691 1.61777,0 1.75477,0.0074 1.84549,0.107048 0.13014,0.142275 0.12458,0.436648 -0.009,0.557445 -0.0957,0.08567 -0.3128,0.09692 -1.85577,0.09692 -1.61778,0 -1.7548,-0.0074 -1.84549,-0.107046 z m -3.42351,-2.881878 c -0.11951,-0.06238 -0.27935,-0.199602 -0.35524,-0.304922 l -0.138,-0.191313 -0.0161,-2.727352 -0.0161,-2.727351 0.13637,-0.200056 c 0.19371,-0.284316 0.47612,-0.452875 0.83211,-0.496577 0.16944,-0.02075 1.02718,-0.02903 1.90638,-0.0184 1.71899,0.02075 1.78821,0.03244 2.07957,0.350549 0.29068,0.317384 0.28753,0.288186 0.30701,2.852572 0.0115,1.575808 -0.004,2.524897 -0.0451,2.715935 -0.0805,0.371541 -0.24648,0.602775 -0.53823,0.75004 -0.21452,0.1082 -0.35046,0.115801 -2.08198,0.113267 -1.7158,-0.0028 -1.86856,-0.01158 -2.06978,-0.11603 z m 3.85627,-0.814637 c 0.0393,-0.07275 0.0612,-0.957573 0.0612,-2.470271 0,-2.110952 -0.009,-2.368122 -0.098,-2.464061 -0.0904,-0.09876 -0.22398,-0.107049 -1.72708,-0.107049 -1.43281,0 -1.64214,0.01146 -1.73736,0.09693 -0.10147,0.09093 -0.10841,0.245217 -0.10841,2.464045 0,1.519728 0.0208,2.407696 0.0612,2.480451 0.0584,0.10797 0.14123,0.113261 1.77406,0.113261 1.63277,0 1.71565,-0.0045 1.77406,-0.113261 z m 2.57762,0.84109 c -0.23901,-0.123392 -0.37788,-0.253614 -0.49462,-0.464046 -0.0852,-0.154011 -0.0999,-0.486173 -0.11535,-2.677649 -0.0115,-1.74742 0.003,-2.576903 0.0501,-2.750966 0.089,-0.326709 0.42817,-0.661148 0.7605,-0.749687 0.17498,-0.04654 0.7997,-0.06237 1.98119,-0.0495 1.47067,0.01605 1.75174,0.03289 1.90312,0.115571 0.23023,0.125691 0.4201,0.329742 0.49928,0.536565 0.0413,0.107971 0.063,1.068207 0.0622,2.782398 -5.6e-4,2.606952 -5.6e-4,2.618441 -0.1343,2.850614 -0.0749,0.130759 -0.23696,0.291107 -0.36908,0.365141 -0.23068,0.129154 -0.27529,0.131917 -2.10055,0.132605 -1.57687,4.36e-4 -1.89238,-0.01387 -2.04245,-0.09093 z m 3.81651,-0.84109 c 0.0393,-0.07275 0.0612,-0.950414 0.0612,-2.447209 0,-2.017546 -0.0115,-2.351521 -0.0922,-2.46405 -0.0915,-0.129159 -0.10425,-0.130077 -1.74231,-0.130077 -1.42118,0 -1.66307,0.01376 -1.74318,0.0921 -0.0817,0.08057 -0.0929,0.389686 -0.0929,2.507064 0,1.800263 0.0184,2.432934 0.071,2.485334 0.0519,0.05157 0.52843,0.07045 1.77405,0.07045 1.62314,0 1.70589,-0.0045 1.7643,-0.113268 z m -2.87752,6.073469 c -0.0208,-0.233572 -0.0608,-0.483986 -0.0878,-0.556482 l -0.0492,-0.131906 h -1.95667 -1.95671 l -0.0494,0.131906 c -0.0273,0.07246 -0.0682,0.32291 -0.0908,0.556482 l -0.0413,0.424684 h 2.13536 2.13537 z m 1.50341,-14.640735 c -0.0231,-0.236011 -0.0652,-0.334361 -0.18839,-0.439317 l -0.15904,-0.135138 h -3.24965 -3.24968 l -0.16065,0.136749 c -0.12088,0.102674 -0.17036,0.211803 -0.19994,0.439333 l -0.0393,0.302596 h 3.63801 3.63802 z"
                                id="path37"
                            />
                        </g>
                        <g id="Dahisar_Station" transform="translate(284.62367,-230.11533)" onClick={() => { handleIconClick('Dahisar_Station'); handleShowDistance({ name: "Dahisar Station", image: dahisarIcon, km: "7.9 KM" }); }}>
                            <g id="g42" transform="translate(122.48971,66.229903)">
                                <g id="g40" transform="translate(69.24619,121.65571)">
                                    <circle
                                        style={{
                                            opacity: 0.5,
                                            fill: "#000000",
                                            stroke: "none",
                                            strokeWidth: 4.99999,
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: 4.2,
                                            strokeDasharray: "none",
                                            strokeDashoffset: 0.0378709,
                                            paintOrder: "stroke fill markers",
                                        }}
                                        id="circle38"
                                        cx={135.11691}
                                        cy={-95.301643}
                                        r={15.610538}
                                    />
                                    <g
                                        style={{
                                            fill: "#f9f9f9",
                                            stroke: "none",
                                            strokeWidth: 206.286,
                                            strokeDasharray: "none",
                                            paintOrder: "stroke markers fill",
                                        }}
                                        id="g39"
                                        transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                    />
                                </g>
                                <g
                                    style={{
                                        fill: "#ffffff",
                                        stroke: "none",
                                        strokeWidth: 172.412,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g41"
                                    transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                                />
                            </g>
                            <path
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                d="m 318.22332,103.22604 c -0.16967,-0.085 -0.29527,-0.3009 -0.2572,-0.44225 0.0139,-0.0537 0.60888,-0.90155 1.32096,-1.88416 1.08465,-1.496698 1.27968,-1.796103 1.20191,-1.845189 -0.52176,-0.329276 -0.66486,-0.448752 -0.82952,-0.692527 -0.10493,-0.155398 -0.21797,-0.379427 -0.25128,-0.497897 -0.0395,-0.14043 -0.0606,-2.400463 -0.0608,-6.491016 -4.6e-4,-7.123749 -0.0331,-6.637739 0.48365,-7.197074 0.42855,-0.463933 0.72138,-0.56673 1.73621,-0.609431 l 0.82885,-0.03501 0.0462,-0.372218 c 0.0793,-0.636229 0.41162,-1.077917 0.92594,-1.230367 0.15766,-0.04665 1.2228,-0.06653 3.53415,-0.06563 3.20228,5.6e-4 3.31716,0.0045 3.57503,0.120858 0.51246,0.229763 0.75216,0.58256 0.80962,1.191191 l 0.0352,0.371177 0.83579,0.02601 c 0.67788,0.02075 0.88746,0.04883 1.10944,0.147114 0.3717,0.16437 0.73921,0.505415 0.92984,0.862753 l 0.15811,0.296589 0.0161,6.351693 c 0.0185,7.022312 0.0332,6.709156 -0.3592,7.219566 -0.1068,0.139048 -0.33455,0.336133 -0.50593,0.437918 -0.17128,0.101756 -0.30998,0.207197 -0.30797,0.234291 0.003,0.02719 0.57627,0.843026 1.27611,1.813179 1.35135,1.87327 1.41108,1.98907 1.14793,2.22486 -0.11603,0.10382 -0.24985,0.11258 -1.93895,0.12661 -1.38732,0.0116 -1.84927,-0.003 -1.96244,-0.0602 -0.10585,-0.054 -0.19717,-0.20421 -0.32064,-0.52764 l -0.1729,-0.45228 h -4.36356 -4.36365 l -0.17243,0.45314 c -0.12298,0.32352 -0.21429,0.47411 -0.31855,0.52631 -0.20873,0.10453 -3.57721,0.1043 -3.78608,-2e-4 z m 3.87463,-2.29713 c 0.30153,-0.83765 0.56705,-1.582297 0.59002,-1.654788 0.0413,-0.130538 0.0363,-0.131687 -0.54423,-0.131687 h -0.58598 l -1.14976,1.590685 c -0.63237,0.87488 -1.17138,1.62668 -1.19779,1.67065 -0.0401,0.0667 0.14979,0.0773 1.14568,0.0642 l 1.19373,-0.016 z m 12.3838,1.4636 c -0.0185,-0.0489 -0.54764,-0.80002 -1.17494,-1.66943 l -1.14057,-1.580759 h -0.57794 c -0.31783,0 -0.57789,0.01605 -0.57789,0.03614 0,0.02833 0.89652,2.539539 1.13199,3.170959 0.0488,0.13052 0.06,0.13168 1.21147,0.13168 1.01358,0 1.15789,-0.0116 1.12788,-0.0886 z m -3.69859,-1.40473 -0.15765,-0.43904 -3.75981,-2.3e-4 -3.75985,-2.4e-4 -0.15974,0.43933 -0.15973,0.43932 h 4.07715 4.07711 z m -0.4832,-1.30167 c 0,-0.02307 -0.0435,-0.15493 -0.0969,-0.29287 l -0.0969,-0.250919 h -3.2418 -3.24179 l -0.0952,0.235491 c -0.0523,0.129608 -0.0952,0.26132 -0.0952,0.292896 0,0.03684 1.23137,0.05736 3.43386,0.05736 1.88864,0 3.43388,-0.01833 3.43388,-0.04184 z m -6.36889,-1.700676 c 0.0929,-0.92809 0.26117,-1.319252 0.64448,-1.499194 0.18006,-0.08453 0.47277,-0.09714 2.28081,-0.09714 1.22525,0 2.13725,0.0236 2.2283,0.05808 0.34258,0.128924 0.595,0.54317 0.65381,1.073017 0.0185,0.167362 0.0476,0.416159 0.0643,0.553077 l 0.0308,0.248954 h 1.52696 c 1.48603,0 1.53219,-0.0045 1.72266,-0.131917 0.10771,-0.07246 0.25147,-0.206276 0.31959,-0.297164 0.12366,-0.165069 0.12389,-0.17681 0.13939,-6.463379 l 0.0161,-6.298002 -0.13176,-0.231923 c -0.0726,-0.127547 -0.22606,-0.289908 -0.34122,-0.360817 l -0.20944,-0.128919 h -6.0136 -6.01361 l -0.23806,0.155857 c -0.46566,0.3049 -0.43415,-0.190854 -0.43415,6.829622 v 6.264811 l 0.13453,0.197522 c 0.074,0.108659 0.22444,0.257585 0.33438,0.330848 0.19486,0.130071 0.23654,0.133287 1.72608,0.133287 h 1.5263 z m -1.98082,-1.214039 c -0.14746,-0.04699 -0.38172,-0.181413 -0.52041,-0.298892 -0.75939,-0.643142 -0.76544,-1.802808 -0.0138,-2.440251 0.25593,-0.216635 0.72429,-0.396129 1.03425,-0.396129 0.56541,0 1.1949,0.386833 1.47324,0.905302 0.18099,0.336918 0.18076,1.074394 -2.4e-4,1.411568 -0.16134,0.300391 -0.45474,0.58813 -0.75683,0.742057 -0.3012,0.153323 -0.86399,0.188779 -1.21726,0.07618 z m 0.86089,-0.817983 c 0.25774,-0.106595 0.44299,-0.401963 0.44299,-0.706443 0,-0.619393 -0.67877,-0.994927 -1.1897,-0.658212 -0.42647,0.281022 -0.50839,0.784232 -0.18885,1.159923 0.251,0.295139 0.55562,0.361808 0.93556,0.204654 z m 7.98366,0.840519 c -0.63982,-0.183483 -1.14661,-0.863592 -1.14553,-1.537437 5.6e-4,-0.629818 0.36847,-1.198462 0.94669,-1.465102 0.4017,-0.185318 1.00165,-0.170589 1.39842,0.03407 1.01958,0.525926 1.17766,1.910465 0.30272,2.651437 -0.38809,0.328644 -1.00657,0.459174 -1.5023,0.317038 z m 1.02242,-1.0075 c 0.36134,-0.390094 0.29726,-0.90325 -0.14956,-1.197674 -0.66623,-0.439064 -1.47292,0.327962 -1.09843,1.044463 0.23973,0.458669 0.89097,0.538622 1.24797,0.153093 z m -6.80692,-0.265824 c -0.13015,-0.142281 -0.12459,-0.436632 0.009,-0.557457 0.0957,-0.08567 0.31277,-0.09691 1.85577,-0.09691 1.61777,0 1.75477,0.0074 1.84549,0.107048 0.13014,0.142275 0.12458,0.436648 -0.009,0.557445 -0.0957,0.08567 -0.3128,0.09692 -1.85577,0.09692 -1.61778,0 -1.7548,-0.0074 -1.84549,-0.107046 z m -3.42351,-2.881878 c -0.11951,-0.06238 -0.27935,-0.199602 -0.35524,-0.304922 l -0.138,-0.191313 -0.0161,-2.727352 -0.0161,-2.727351 0.13637,-0.200056 c 0.19371,-0.284316 0.47612,-0.452875 0.83211,-0.496577 0.16944,-0.02075 1.02718,-0.02903 1.90638,-0.0184 1.71899,0.02075 1.78821,0.03244 2.07957,0.350549 0.29068,0.317384 0.28753,0.288186 0.30701,2.852572 0.0115,1.575808 -0.004,2.524897 -0.0451,2.715935 -0.0805,0.371541 -0.24648,0.602775 -0.53823,0.75004 -0.21452,0.1082 -0.35046,0.115801 -2.08198,0.113267 -1.7158,-0.0028 -1.86856,-0.01158 -2.06978,-0.11603 z m 3.85627,-0.814637 c 0.0393,-0.07275 0.0612,-0.957573 0.0612,-2.470271 0,-2.110952 -0.009,-2.368122 -0.098,-2.464061 -0.0904,-0.09876 -0.22398,-0.107049 -1.72708,-0.107049 -1.43281,0 -1.64214,0.01146 -1.73736,0.09693 -0.10147,0.09093 -0.10841,0.245217 -0.10841,2.464045 0,1.519728 0.0208,2.407696 0.0612,2.480451 0.0584,0.10797 0.14123,0.113261 1.77406,0.113261 1.63277,0 1.71565,-0.0045 1.77406,-0.113261 z m 2.57762,0.84109 c -0.23901,-0.123392 -0.37788,-0.253614 -0.49462,-0.464046 -0.0852,-0.154011 -0.0999,-0.486173 -0.11535,-2.677649 -0.0115,-1.74742 0.003,-2.576903 0.0501,-2.750966 0.089,-0.326709 0.42817,-0.661148 0.7605,-0.749687 0.17498,-0.04654 0.7997,-0.06237 1.98119,-0.0495 1.47067,0.01605 1.75174,0.03289 1.90312,0.115571 0.23023,0.125691 0.4201,0.329742 0.49928,0.536565 0.0413,0.107971 0.063,1.068207 0.0622,2.782398 -5.6e-4,2.606952 -5.6e-4,2.618441 -0.1343,2.850614 -0.0749,0.130759 -0.23696,0.291107 -0.36908,0.365141 -0.23068,0.129154 -0.27529,0.131917 -2.10055,0.132605 -1.57687,4.36e-4 -1.89238,-0.01387 -2.04245,-0.09093 z m 3.81651,-0.84109 c 0.0393,-0.07275 0.0612,-0.950414 0.0612,-2.447209 0,-2.017546 -0.0115,-2.351521 -0.0922,-2.46405 -0.0915,-0.129159 -0.10425,-0.130077 -1.74231,-0.130077 -1.42118,0 -1.66307,0.01376 -1.74318,0.0921 -0.0817,0.08057 -0.0929,0.389686 -0.0929,2.507064 0,1.800263 0.0184,2.432934 0.071,2.485334 0.0519,0.05157 0.52843,0.07045 1.77405,0.07045 1.62314,0 1.70589,-0.0045 1.7643,-0.113268 z m -2.87752,6.073469 c -0.0208,-0.233572 -0.0608,-0.483986 -0.0878,-0.556482 l -0.0492,-0.131906 h -1.95667 -1.95671 l -0.0494,0.131906 c -0.0273,0.07246 -0.0682,0.32291 -0.0908,0.556482 l -0.0413,0.424684 h 2.13536 2.13537 z m 1.50341,-14.640735 c -0.0231,-0.236011 -0.0652,-0.334361 -0.18839,-0.439317 l -0.15904,-0.135138 h -3.24965 -3.24968 l -0.16065,0.136749 c -0.12088,0.102674 -0.17036,0.211803 -0.19994,0.439333 l -0.0393,0.302596 h 3.63801 3.63802 z"
                                id="path42"
                            />
                        </g>
                        <g id="DMart" onClick={() => { handleIconClick('DMart'); handleShowDistance({ name: "D Mart", image: dmartIcon, km: "2.1 KM" }); }}>
                            <g id="g48" transform="translate(-56.882643,106.04805)">
                                <g id="g47" transform="translate(122.48971,66.229903)">
                                    <g id="g45" transform="translate(69.24619,121.65571)">
                                        <circle
                                            style={{
                                                opacity: 0.5,
                                                fill: "#000000",
                                                stroke: "none",
                                                strokeWidth: 4.99999,
                                                strokeLinejoin: "round",
                                                strokeMiterlimit: 4.2,
                                                strokeDasharray: "none",
                                                strokeDashoffset: 0.0378709,
                                                paintOrder: "stroke fill markers",
                                            }}
                                            id="circle43"
                                            cx={135.11691}
                                            cy={-95.301643}
                                            r={15.610538}
                                        />
                                        <g
                                            style={{
                                                fill: "#f9f9f9",
                                                stroke: "none",
                                                strokeWidth: 206.286,
                                                strokeDasharray: "none",
                                                paintOrder: "stroke markers fill",
                                            }}
                                            id="g44"
                                            transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                        />
                                    </g>
                                    <g
                                        style={{
                                            fill: "#ffffff",
                                            stroke: "none",
                                            strokeWidth: 172.412,
                                            strokeDasharray: "none",
                                            paintOrder: "stroke markers fill",
                                        }}
                                        id="g46"
                                        transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                                    />
                                </g>
                            </g>
                            <path
                                id="D__Mart"
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                d="m 260.52058,207.97256 v -0.37969 h 9.44959 9.44959 v 0.37969 0.3797 h -9.44959 -9.44959 z m 1.06261,-6.28671 v -5.33748 l 0.21821,0.1244 c 0.12002,0.0685 0.26507,0.15085 0.32233,0.18315 l 0.10414,0.0587 2.8e-4,5.15433 3e-4,5.15433 h -0.32258 -0.32258 z m 1.2144,0.34291 v -4.99457 l 0.16129,0.0939 c 0.0887,0.0516 0.51992,0.29752 0.95825,0.54638 l 0.79694,0.45246 0.0102,4.44818 0.0102,4.4482 h -0.96789 -0.96789 z m 2.51298,2.89676 c 0.0102,-2.05109 0.0125,-2.10172 0.0919,-2.27332 0.29544,-0.63927 1.35171,-1.18015 2.76515,-1.41594 1.26319,-0.21071 3.07979,-0.16273 4.15874,0.10986 1.01277,0.25589 1.76605,0.64971 2.0848,1.08997 0.22407,0.30949 0.22697,0.34197 0.22697,2.56277 v 2.02446 h -1.19544 -1.19543 v -1.67065 c 0,-1.47891 0.007,-1.67064 0.0585,-1.67064 0.17547,0 0.50829,-0.26635 0.58429,-0.4676 0.0558,-0.14757 0.0504,-0.42179 -0.0102,-0.56829 -0.0697,-0.16666 -0.33444,-0.39771 -0.4874,-0.42542 -0.0691,-0.0125 -1.20276,-0.0177 -2.51928,-0.0116 l -2.39365,0.0114 -0.13345,0.0915 c -0.36748,0.25199 -0.45178,0.77405 -0.17575,1.08859 0.11998,0.13674 0.35935,0.28173 0.4651,0.28173 0.0517,0 0.0585,0.19173 0.0585,1.67065 v 1.67065 h -1.19665 -1.19666 z m 2.95184,0.42715 v -1.67232 l 0.71156,0.0102 0.71157,0.0102 v 1.65166 1.65166 l -0.71157,0.0102 -0.71156,0.0102 z m 1.99077,1.6232 c -0.0102,-0.0261 -0.0137,-0.77363 -0.008,-1.66116 l 0.0102,-1.61371 0.71157,-0.0102 0.71157,-0.0102 v 1.67149 1.67149 h -0.70327 c -0.52761,0 -0.70782,-0.0119 -0.72148,-0.0474 z m 4.96344,-4.40054 0.0102,-4.44801 0.79695,-0.45229 c 0.43832,-0.24876 0.86954,-0.49471 0.95824,-0.54656 l 0.16128,-0.0943 v 4.99456 4.99457 h -0.96788 -0.96789 z m 2.49562,-0.70635 3e-4,-5.15433 0.10413,-0.0587 c 0.0573,-0.0323 0.20232,-0.11471 0.32235,-0.18313 l 0.2182,-0.12441 v 5.33749 5.33747 h -0.32257 -0.32258 z m -10.08739,1.19793 c -0.025,-0.0251 -0.0455,-0.0815 -0.0455,-0.12529 0,-0.0438 0.0206,-0.10022 0.0455,-0.12531 0.0658,-0.0658 4.62486,-0.0658 4.69064,0 0.025,0.0251 0.0456,0.0815 0.0456,0.12531 0,0.0438 -0.0206,0.10022 -0.0456,0.12529 -0.0658,0.0658 -4.62485,0.0658 -4.69064,0 z m -2.32255,-2.13315 c 0,-0.6376 0.0145,-0.93278 0.0517,-1.05673 0.11483,-0.38172 0.46082,-0.72044 1.02844,-1.00682 0.27032,-0.13637 1.02631,-0.39803 1.28278,-0.44397 l 0.14286,-0.0256 -0.0102,1.16347 -0.0102,1.16346 -0.41745,0.10635 c -0.2296,0.0585 -0.50284,0.13525 -0.6072,0.17053 -0.35784,0.12096 -0.94886,0.42475 -1.20492,0.61934 l -0.25616,0.19466 z m 9.10804,0.70809 c -0.39201,-0.31306 -1.20331,-0.66598 -1.89751,-0.82542 -0.15655,-0.036 -0.30596,-0.0717 -0.33205,-0.0795 -0.0366,-0.0113 -0.0474,-0.27918 -0.0474,-1.17512 v -1.16097 l 0.14231,0.0256 c 0.24634,0.0442 1.00855,0.30568 1.2637,0.43365 0.51752,0.25956 0.7909,0.50096 0.98886,0.87323 0.0856,0.1611 0.0915,0.2142 0.10289,0.93024 0.007,0.41767 0.007,0.84617 0,0.95224 l -0.012,0.19284 z m -6.03408,-2.16939 v -1.17347 l 0.12334,-0.0206 c 0.0678,-0.0114 0.42647,-0.0417 0.79696,-0.0676 0.53557,-0.0373 0.81166,-0.0373 1.34722,0 0.37049,0.0259 0.72912,0.0563 0.79696,0.0676 l 0.12334,0.0206 v 1.17347 1.17346 l -0.0854,-0.0201 c -0.49992,-0.11733 -2.51711,-0.11733 -3.01703,0 l -0.0854,0.0201 z m -3.06739,-1.52801 0.0124,-0.96401 0.11287,-0.20383 c 0.279,-0.50399 1.07673,-0.97439 2.0693,-1.22023 0.0939,-0.0233 0.2009,-0.0511 0.23774,-0.0617 0.0631,-0.0184 0.0663,0.0479 0.0569,1.14966 l -0.0102,1.16912 -0.39847,0.10192 c -0.8603,0.2201 -1.41702,0.47549 -1.98583,0.91099 l -0.10731,0.0822 z m 9.06427,0.76129 c -0.44971,-0.33851 -1.32158,-0.70189 -2.00262,-0.83465 l -0.23719,-0.0461 v -1.17467 c 0,-1.10086 0.005,-1.17344 0.0663,-1.15513 0.0365,0.0114 0.16888,0.0455 0.29412,0.0773 0.86966,0.2206 1.57245,0.60453 1.90494,1.04066 0.21405,0.28078 0.242,0.45304 0.23048,1.42028 l -0.0102,0.85756 z m -5.99688,-2.15142 v -1.17646 l 0.42917,-0.0436 c 0.55148,-0.056 1.778,-0.056 2.32949,0 l 0.42916,0.0436 v 1.17646 1.17644 l -0.14232,-0.0233 c -0.0782,-0.0129 -0.44343,-0.0429 -0.81146,-0.0669 -0.63625,-0.0415 -1.63374,-0.0102 -2.09172,0.0665 l -0.14232,0.0238 z m -3.07396,-1.42765 c 0,-1.0255 0.027,-1.16923 0.277,-1.4761 0.0879,-0.10794 0.26757,-0.26995 0.39926,-0.3601 l 0.23942,-0.16393 h 0.79451 0.79453 v 0.8882 0.88819 l -0.27515,0.0658 c -0.83073,0.19891 -1.58038,0.51939 -1.99238,0.85177 l -0.23719,0.19134 z m 9.09498,0.69141 c -0.40486,-0.32686 -1.16801,-0.65275 -1.98882,-0.84928 l -0.27513,-0.0658 v -0.88819 -0.8882 h 0.79262 0.79264 l 0.2314,0.15461 c 0.26639,0.17799 0.46125,0.39166 0.58351,0.63989 0.0786,0.15961 0.0865,0.23544 0.0976,0.93311 0.007,0.41766 0.007,0.8457 0,0.9512 l -0.012,0.19179 z m -6.02102,-1.85337 v -0.83817 h 1.59391 1.59391 v 0.83762 0.83762 l -0.37002,-0.0307 c -0.48068,-0.04 -2.01651,-0.0396 -2.46675,5.6e-4 l -0.35105,0.0313 z m -3.97632,-1.46682 -0.0844,-0.0592 v -1.70059 c 0,-1.59928 0.005,-1.70433 0.0694,-1.76343 0.0639,-0.0579 0.5064,-0.0629 5.59175,-0.0629 5.3018,0 5.52489,0.002 5.58519,0.0695 0.0565,0.0624 0.0628,0.23926 0.0628,1.74659 0,1.62653 -0.002,1.67944 -0.0759,1.75309 -0.0752,0.0752 -0.12651,0.0759 -5.57024,0.0759 -4.91138,0 -5.50327,-0.006 -5.57868,-0.0592 z m 1.00475,-0.55789 c 0.0448,-0.0494 0.14477,-0.31822 0.23638,-0.63598 0.0874,-0.30281 0.16863,-0.58404 0.18071,-0.62493 0.0234,-0.0791 0.0204,-0.0854 0.25821,0.54486 0.12236,0.32427 0.20425,0.42179 0.35419,0.42179 0.16029,0 0.24858,-0.12506 0.40884,-0.57912 0.0793,-0.22453 0.15602,-0.3954 0.1706,-0.37969 0.0146,0.0156 0.0887,0.2336 0.1647,0.48419 0.19712,0.64991 0.24681,0.77443 0.32589,0.81677 0.19089,0.10226 0.41665,-0.0195 0.41665,-0.22457 0,-0.16413 -0.62439,-2.15798 -0.703,-2.2449 -0.0979,-0.10816 -0.29698,-0.0993 -0.3887,0.0174 -0.0399,0.0507 -0.14598,0.30063 -0.23573,0.55527 l -0.16318,0.46299 -0.18662,-0.48821 c -0.10266,-0.26851 -0.21392,-0.51838 -0.24727,-0.55526 -0.0867,-0.0958 -0.28428,-0.0862 -0.37761,0.0184 -0.0477,0.0533 -0.19275,0.4864 -0.38666,1.15418 -0.24913,0.85794 -0.30319,1.08765 -0.27398,1.16451 0.0713,0.1874 0.31444,0.23772 0.44658,0.0924 z m 3.43698,0.0379 c 0.0344,-0.0261 0.0968,-0.12863 0.13873,-0.22783 l 0.0763,-0.18035 h 0.45569 0.45569 l 0.0822,0.19136 c 0.0453,0.10521 0.11286,0.20777 0.15035,0.22782 0.19082,0.10215 0.41463,-0.0218 0.41463,-0.22969 0,-0.12857 -0.83545,-2.13557 -0.93462,-2.24518 -0.0939,-0.10385 -0.29492,-0.0926 -0.38467,0.0216 -0.10732,0.1365 -0.88182,2.08876 -0.88182,2.22278 0,0.21414 0.25931,0.34732 0.42745,0.21953 z m 0.52582,-1.17706 c 0.0437,-0.10964 0.0913,-0.23091 0.10606,-0.2695 0.0207,-0.0545 0.0496,-0.0163 0.12897,0.17086 0.0563,0.13256 0.10221,0.25385 0.10221,0.26951 -7e-5,0.0157 -0.0938,0.0284 -0.20829,0.0284 h -0.20817 z m 3.40384,1.1471 c 0.12041,-0.11225 0.11219,-0.31177 -0.0169,-0.41343 -0.0889,-0.0701 -0.15198,-0.0786 -0.56926,-0.0786 h -0.46926 v -0.90614 c 0,-0.85924 -0.005,-0.91133 -0.0786,-1.00619 -0.10879,-0.13836 -0.30316,-0.13836 -0.41193,0 -0.0755,0.096 -0.0786,0.14472 -0.0786,1.19775 v 1.09772 l 0.0931,0.0932 c 0.092,0.092 0.10187,0.0932 0.77082,0.0932 0.62953,0 0.68357,-0.006 0.76073,-0.0774 z m 2.09872,0.0372 c 0.18203,-0.0975 0.16492,-0.39859 -0.0277,-0.48637 -0.0532,-0.0241 -0.2914,-0.0429 -0.54771,-0.0429 H 273.841 v -0.93025 c 0,-0.87963 -0.005,-0.93438 -0.0759,-1.00619 -0.0958,-0.0959 -0.26861,-0.0975 -0.38478,-0.003 l -0.0896,0.0725 -0.0113,1.05692 c -0.006,0.58132 -0.002,1.09587 0.0103,1.14346 0.0119,0.0476 0.0554,0.12026 0.0966,0.16149 0.0689,0.069 0.12841,0.0751 0.74156,0.0751 0.39732,0 0.69701,-0.0163 0.74185,-0.0403 z"

                            />
                        </g>
                        <g id="Maxus_Mall" transform="translate(-45.577567,42.372895)" onClick={() => { handleIconClick('Maxus_Mall'); handleShowDistance({ name: "Maxus Mall", image: maxusMallIcon, km: "2.1 KM" }); }}>
                            <g id="g54" transform="translate(-56.882643,106.04805)">
                                <g id="g53" transform="translate(122.48971,66.229903)">
                                    <g id="g51" transform="translate(69.24619,121.65571)">
                                        <circle
                                            style={{
                                                opacity: 0.5,
                                                fill: "#000000",
                                                stroke: "none",
                                                strokeWidth: 4.99999,
                                                strokeLinejoin: "round",
                                                strokeMiterlimit: 4.2,
                                                strokeDasharray: "none",
                                                strokeDashoffset: 0.0378709,
                                                paintOrder: "stroke fill markers",
                                            }}
                                            id="circle49"
                                            cx={135.11691}
                                            cy={-95.301643}
                                            r={15.610538}
                                        />
                                        <g
                                            style={{
                                                fill: "#f9f9f9",
                                                stroke: "none",
                                                strokeWidth: 206.286,
                                                strokeDasharray: "none",
                                                paintOrder: "stroke markers fill",
                                            }}
                                            id="g50"
                                            transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                        />
                                    </g>
                                    <g
                                        style={{
                                            fill: "#ffffff",
                                            stroke: "none",
                                            strokeWidth: 172.412,
                                            strokeDasharray: "none",
                                            paintOrder: "stroke markers fill",
                                        }}
                                        id="g52"
                                        transform="matrix(0.02320011,0,0,0.02320011,193.22705,37.490124)"
                                    />
                                </g>
                            </g>
                            <path
                                id="path54"
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 4,
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                d="m 260.52058,207.97256 v -0.37969 h 9.44959 9.44959 v 0.37969 0.3797 h -9.44959 -9.44959 z m 1.06261,-6.28671 v -5.33748 l 0.21821,0.1244 c 0.12002,0.0685 0.26507,0.15085 0.32233,0.18315 l 0.10414,0.0587 2.8e-4,5.15433 3e-4,5.15433 h -0.32258 -0.32258 z m 1.2144,0.34291 v -4.99457 l 0.16129,0.0939 c 0.0887,0.0516 0.51992,0.29752 0.95825,0.54638 l 0.79694,0.45246 0.0102,4.44818 0.0102,4.4482 h -0.96789 -0.96789 z m 2.51298,2.89676 c 0.0102,-2.05109 0.0125,-2.10172 0.0919,-2.27332 0.29544,-0.63927 1.35171,-1.18015 2.76515,-1.41594 1.26319,-0.21071 3.07979,-0.16273 4.15874,0.10986 1.01277,0.25589 1.76605,0.64971 2.0848,1.08997 0.22407,0.30949 0.22697,0.34197 0.22697,2.56277 v 2.02446 h -1.19544 -1.19543 v -1.67065 c 0,-1.47891 0.007,-1.67064 0.0585,-1.67064 0.17547,0 0.50829,-0.26635 0.58429,-0.4676 0.0558,-0.14757 0.0504,-0.42179 -0.0102,-0.56829 -0.0697,-0.16666 -0.33444,-0.39771 -0.4874,-0.42542 -0.0691,-0.0125 -1.20276,-0.0177 -2.51928,-0.0116 l -2.39365,0.0114 -0.13345,0.0915 c -0.36748,0.25199 -0.45178,0.77405 -0.17575,1.08859 0.11998,0.13674 0.35935,0.28173 0.4651,0.28173 0.0517,0 0.0585,0.19173 0.0585,1.67065 v 1.67065 h -1.19665 -1.19666 z m 2.95184,0.42715 v -1.67232 l 0.71156,0.0102 0.71157,0.0102 v 1.65166 1.65166 l -0.71157,0.0102 -0.71156,0.0102 z m 1.99077,1.6232 c -0.0102,-0.0261 -0.0137,-0.77363 -0.008,-1.66116 l 0.0102,-1.61371 0.71157,-0.0102 0.71157,-0.0102 v 1.67149 1.67149 h -0.70327 c -0.52761,0 -0.70782,-0.0119 -0.72148,-0.0474 z m 4.96344,-4.40054 0.0102,-4.44801 0.79695,-0.45229 c 0.43832,-0.24876 0.86954,-0.49471 0.95824,-0.54656 l 0.16128,-0.0943 v 4.99456 4.99457 h -0.96788 -0.96789 z m 2.49562,-0.70635 3e-4,-5.15433 0.10413,-0.0587 c 0.0573,-0.0323 0.20232,-0.11471 0.32235,-0.18313 l 0.2182,-0.12441 v 5.33749 5.33747 h -0.32257 -0.32258 z m -10.08739,1.19793 c -0.025,-0.0251 -0.0455,-0.0815 -0.0455,-0.12529 0,-0.0438 0.0206,-0.10022 0.0455,-0.12531 0.0658,-0.0658 4.62486,-0.0658 4.69064,0 0.025,0.0251 0.0456,0.0815 0.0456,0.12531 0,0.0438 -0.0206,0.10022 -0.0456,0.12529 -0.0658,0.0658 -4.62485,0.0658 -4.69064,0 z m -2.32255,-2.13315 c 0,-0.6376 0.0145,-0.93278 0.0517,-1.05673 0.11483,-0.38172 0.46082,-0.72044 1.02844,-1.00682 0.27032,-0.13637 1.02631,-0.39803 1.28278,-0.44397 l 0.14286,-0.0256 -0.0102,1.16347 -0.0102,1.16346 -0.41745,0.10635 c -0.2296,0.0585 -0.50284,0.13525 -0.6072,0.17053 -0.35784,0.12096 -0.94886,0.42475 -1.20492,0.61934 l -0.25616,0.19466 z m 9.10804,0.70809 c -0.39201,-0.31306 -1.20331,-0.66598 -1.89751,-0.82542 -0.15655,-0.036 -0.30596,-0.0717 -0.33205,-0.0795 -0.0366,-0.0113 -0.0474,-0.27918 -0.0474,-1.17512 v -1.16097 l 0.14231,0.0256 c 0.24634,0.0442 1.00855,0.30568 1.2637,0.43365 0.51752,0.25956 0.7909,0.50096 0.98886,0.87323 0.0856,0.1611 0.0915,0.2142 0.10289,0.93024 0.007,0.41767 0.007,0.84617 0,0.95224 l -0.012,0.19284 z m -6.03408,-2.16939 v -1.17347 l 0.12334,-0.0206 c 0.0678,-0.0114 0.42647,-0.0417 0.79696,-0.0676 0.53557,-0.0373 0.81166,-0.0373 1.34722,0 0.37049,0.0259 0.72912,0.0563 0.79696,0.0676 l 0.12334,0.0206 v 1.17347 1.17346 l -0.0854,-0.0201 c -0.49992,-0.11733 -2.51711,-0.11733 -3.01703,0 l -0.0854,0.0201 z m -3.06739,-1.52801 0.0124,-0.96401 0.11287,-0.20383 c 0.279,-0.50399 1.07673,-0.97439 2.0693,-1.22023 0.0939,-0.0233 0.2009,-0.0511 0.23774,-0.0617 0.0631,-0.0184 0.0663,0.0479 0.0569,1.14966 l -0.0102,1.16912 -0.39847,0.10192 c -0.8603,0.2201 -1.41702,0.47549 -1.98583,0.91099 l -0.10731,0.0822 z m 9.06427,0.76129 c -0.44971,-0.33851 -1.32158,-0.70189 -2.00262,-0.83465 l -0.23719,-0.0461 v -1.17467 c 0,-1.10086 0.005,-1.17344 0.0663,-1.15513 0.0365,0.0114 0.16888,0.0455 0.29412,0.0773 0.86966,0.2206 1.57245,0.60453 1.90494,1.04066 0.21405,0.28078 0.242,0.45304 0.23048,1.42028 l -0.0102,0.85756 z m -5.99688,-2.15142 v -1.17646 l 0.42917,-0.0436 c 0.55148,-0.056 1.778,-0.056 2.32949,0 l 0.42916,0.0436 v 1.17646 1.17644 l -0.14232,-0.0233 c -0.0782,-0.0129 -0.44343,-0.0429 -0.81146,-0.0669 -0.63625,-0.0415 -1.63374,-0.0102 -2.09172,0.0665 l -0.14232,0.0238 z m -3.07396,-1.42765 c 0,-1.0255 0.027,-1.16923 0.277,-1.4761 0.0879,-0.10794 0.26757,-0.26995 0.39926,-0.3601 l 0.23942,-0.16393 h 0.79451 0.79453 v 0.8882 0.88819 l -0.27515,0.0658 c -0.83073,0.19891 -1.58038,0.51939 -1.99238,0.85177 l -0.23719,0.19134 z m 9.09498,0.69141 c -0.40486,-0.32686 -1.16801,-0.65275 -1.98882,-0.84928 l -0.27513,-0.0658 v -0.88819 -0.8882 h 0.79262 0.79264 l 0.2314,0.15461 c 0.26639,0.17799 0.46125,0.39166 0.58351,0.63989 0.0786,0.15961 0.0865,0.23544 0.0976,0.93311 0.007,0.41766 0.007,0.8457 0,0.9512 l -0.012,0.19179 z m -6.02102,-1.85337 v -0.83817 h 1.59391 1.59391 v 0.83762 0.83762 l -0.37002,-0.0307 c -0.48068,-0.04 -2.01651,-0.0396 -2.46675,5.6e-4 l -0.35105,0.0313 z m -3.97632,-1.46682 -0.0844,-0.0592 v -1.70059 c 0,-1.59928 0.005,-1.70433 0.0694,-1.76343 0.0639,-0.0579 0.5064,-0.0629 5.59175,-0.0629 5.3018,0 5.52489,0.002 5.58519,0.0695 0.0565,0.0624 0.0628,0.23926 0.0628,1.74659 0,1.62653 -0.002,1.67944 -0.0759,1.75309 -0.0752,0.0752 -0.12651,0.0759 -5.57024,0.0759 -4.91138,0 -5.50327,-0.006 -5.57868,-0.0592 z m 1.00475,-0.55789 c 0.0448,-0.0494 0.14477,-0.31822 0.23638,-0.63598 0.0874,-0.30281 0.16863,-0.58404 0.18071,-0.62493 0.0234,-0.0791 0.0204,-0.0854 0.25821,0.54486 0.12236,0.32427 0.20425,0.42179 0.35419,0.42179 0.16029,0 0.24858,-0.12506 0.40884,-0.57912 0.0793,-0.22453 0.15602,-0.3954 0.1706,-0.37969 0.0146,0.0156 0.0887,0.2336 0.1647,0.48419 0.19712,0.64991 0.24681,0.77443 0.32589,0.81677 0.19089,0.10226 0.41665,-0.0195 0.41665,-0.22457 0,-0.16413 -0.62439,-2.15798 -0.703,-2.2449 -0.0979,-0.10816 -0.29698,-0.0993 -0.3887,0.0174 -0.0399,0.0507 -0.14598,0.30063 -0.23573,0.55527 l -0.16318,0.46299 -0.18662,-0.48821 c -0.10266,-0.26851 -0.21392,-0.51838 -0.24727,-0.55526 -0.0867,-0.0958 -0.28428,-0.0862 -0.37761,0.0184 -0.0477,0.0533 -0.19275,0.4864 -0.38666,1.15418 -0.24913,0.85794 -0.30319,1.08765 -0.27398,1.16451 0.0713,0.1874 0.31444,0.23772 0.44658,0.0924 z m 3.43698,0.0379 c 0.0344,-0.0261 0.0968,-0.12863 0.13873,-0.22783 l 0.0763,-0.18035 h 0.45569 0.45569 l 0.0822,0.19136 c 0.0453,0.10521 0.11286,0.20777 0.15035,0.22782 0.19082,0.10215 0.41463,-0.0218 0.41463,-0.22969 0,-0.12857 -0.83545,-2.13557 -0.93462,-2.24518 -0.0939,-0.10385 -0.29492,-0.0926 -0.38467,0.0216 -0.10732,0.1365 -0.88182,2.08876 -0.88182,2.22278 0,0.21414 0.25931,0.34732 0.42745,0.21953 z m 0.52582,-1.17706 c 0.0437,-0.10964 0.0913,-0.23091 0.10606,-0.2695 0.0207,-0.0545 0.0496,-0.0163 0.12897,0.17086 0.0563,0.13256 0.10221,0.25385 0.10221,0.26951 -7e-5,0.0157 -0.0938,0.0284 -0.20829,0.0284 h -0.20817 z m 3.40384,1.1471 c 0.12041,-0.11225 0.11219,-0.31177 -0.0169,-0.41343 -0.0889,-0.0701 -0.15198,-0.0786 -0.56926,-0.0786 h -0.46926 v -0.90614 c 0,-0.85924 -0.005,-0.91133 -0.0786,-1.00619 -0.10879,-0.13836 -0.30316,-0.13836 -0.41193,0 -0.0755,0.096 -0.0786,0.14472 -0.0786,1.19775 v 1.09772 l 0.0931,0.0932 c 0.092,0.092 0.10187,0.0932 0.77082,0.0932 0.62953,0 0.68357,-0.006 0.76073,-0.0774 z m 2.09872,0.0372 c 0.18203,-0.0975 0.16492,-0.39859 -0.0277,-0.48637 -0.0532,-0.0241 -0.2914,-0.0429 -0.54771,-0.0429 H 273.841 v -0.93025 c 0,-0.87963 -0.005,-0.93438 -0.0759,-1.00619 -0.0958,-0.0959 -0.26861,-0.0975 -0.38478,-0.003 l -0.0896,0.0725 -0.0113,1.05692 c -0.006,0.58132 -0.002,1.09587 0.0103,1.14346 0.0119,0.0476 0.0554,0.12026 0.0966,0.16149 0.0689,0.069 0.12841,0.0751 0.74156,0.0751 0.39732,0 0.69701,-0.0163 0.74185,-0.0403 z"
                            />
                        </g>
                        <g id="g58" onClick={() => {
                            handleIconClick('Mac_Donald');
                            // handleShowDistance({ name: "Mac Donald", image: macDIcon, km: "1.2 KM" }); 
                        }}>
                            <g id="g57" transform="translate(-40.349645,109.93965)">
                                <circle
                                    style={{
                                        opacity: 0.5,
                                        fill: "#000000",
                                        stroke: "none",
                                        strokeWidth: 4.99999,
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 4.2,
                                        strokeDasharray: "none",
                                        strokeDashoffset: 0.0378709,
                                        paintOrder: "stroke fill markers",
                                    }}
                                    id="circle55"
                                    cx={135.11691}
                                    cy={-95.301643}
                                    r={15.610538}
                                />
                                <g
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 206.286,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                    id="g56"
                                    transform="matrix(0.02931418,0,0,0.02885938,121.0461,-81.700923)"
                                />
                            </g>
                            <g
                                style={{
                                    fill: "#f9f9f9",
                                    stroke: "none",
                                    strokeWidth: 241.671,
                                    strokeDasharray: "none",
                                    paintOrder: "stroke markers fill",
                                }}
                                id="Mac_Donald"
                                transform="matrix(0.01688103,0,0,0.01622823,86.664373,22.427557)"
                            >
                                <path
                                    d="m 160,-120 q -33,0 -56.5,-23.5 Q 80,-167 80,-200 v -120 h 800 v 120 q 0,33 -23.5,56.5 Q 833,-120 800,-120 Z m 0,-120 v 40 h 640 v -40 z m 320,-180 q -36,0 -57,20 -21,20 -77,20 -56,0 -76,-20 -20,-20 -56,-20 -36,0 -57,20 -21,20 -77,20 v -80 q 36,0 57,-20 21,-20 77,-20 56,0 76,20 20,20 56,20 36,0 57,-20 21,-20 77,-20 56,0 77,20 21,20 57,20 36,0 56,-20 20,-20 76,-20 56,0 79,20 23,20 55,20 v 80 q -56,0 -75,-20 -19,-20 -55,-20 -36,0 -58,20 -22,20 -78,20 -56,0 -77,-20 -21,-20 -57,-20 z M 80,-560 v -40 Q 80,-715 188.5,-777.5 297,-840 480,-840 q 183,0 291.5,62.5 Q 880,-715 880,-600 v 40 z m 400,-200 q -124,0 -207.5,31 -83.5,31 -106.5,89 H 794 Q 771,-698 687.5,-729 604,-760 480,-760 Z m 0,520 z m 0,-400 z"
                                    id="path1-9"
                                    style={{
                                        fill: "#f9f9f9",
                                        stroke: "none",
                                        strokeWidth: 241.671,
                                        strokeDasharray: "none",
                                        paintOrder: "stroke markers fill",
                                    }}
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            {
                distanceDetailsModel &&
                <div className="distance_details_card_conianter" ref={modalRef}>
                    <div className={`distance_details_card rounded-3 ${distanceDetailsModel ? "show" : ""}`}>
                        <img src={distanceDetails?.image} alt={distanceDetails?.name} className="distance_details_image" />
                        <div className="text-details">
                            <p>{distanceDetails?.name}</p>
                            <p className="mb-0"><img src={distance} alt="nav-icon" className="distance_details_nav_icon" /><span className="distance_details_km">{distanceDetails?.km}</span></p>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default LocationSkyCrest8;
